import { CreateElement } from "./element";

type BreakType = "line" | "page" | "column";

interface OptionsBreak {}

/**
 * Create break
 */
class CreateBreak extends CreateElement {
    /**
     * Element options
     */
    protected options: OptionsBreak;

    /**
     * Type
     */
    protected type: string;

    /**
     * Constructor
     *
     * @param options - Options break
     */
    constructor(options: OptionsBreak, type: BreakType = "line") {
        super();

        this.options = options;
        this.type = type;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        const contents = '<w:br w:type="' + this.type + '" />';

        return contents;
    }
}

export { BreakType, CreateBreak, OptionsBreak };
